import { observable, computed, action, makeObservable } from 'mobx';

class AuthStore {
    isAuth;
    isOpen;
    userId;
    user;
    useExtendedPanel;
    isDeveloper;
    isPortal;
    isAdmin;
    callback;
    useExperimentalMode;

    constructor() {
        
        this.callback = () => { };
        this.isAuth = !!localStorage.getItem('token');
        this.isOpen = false;
        this.user = !!localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        this.userId = localStorage.getItem('userId');
        this.useExtendedPanel = localStorage.getItem('useExtendedPanel') === "true";
        this.isDeveloper = localStorage.getItem('isDeveloper') === "true";
        this.isPortal = localStorage.getItem('isPortal') === "true";
        this.isAdmin = localStorage.getItem('isAdmin') === "true";
        this.useExperimentalMode = localStorage.getItem('useExperimentalMode') === "true";

        makeObservable(this, {
            userId: observable,
            callback: observable,
            useExperimentalMode: observable,
            isPortal: observable,
            isAdmin: observable,
            useExtendedPanel: observable,
            isDeveloper: observable,
            isAuth: observable,
            isOpen: observable,
            isUserAuth: computed,
            isLoginOpened: computed,
            getIsDeveloper: computed,
            getCallback: computed,
            getUseExperimentalMode: computed,
            getIsPortal: computed,
            getIsAdmin: computed,
            getUserId: computed,
            getUseExtendedPanel: computed,
            setUserAuth: action,
            setIsPortal: action,
            setIsAdmin: action,
            setExperimentalMode: action,
            setUseExtendedPanel: action,
            setUserNonAuth: action,
            closeLogin: action,
            setUserId: action,
            openLogin: action,

            user: observable,
            getUser: computed,
            setUser: action


        });
    }

    get isUserAuth() {
        return this.isAuth;
    }

    get isLoginOpened() {
        return this.isOpen;
    }

    get getUserId() {
        return this.userId;
    }

    get getIsDeveloper() {
        return this.isDeveloper;
    }

    get getIsPortal() {
        return this.isPortal;
    }

    get getIsAdmin() {
        return this.isAdmin;
    }

    get getUseExtendedPanel() {
        return this.useExtendedPanel;
    }

    get getUser() {
        return this.user;
    }

    setUser(user) {
        this.user = user;
        localStorage.setItem('user', JSON.stringify(user));
    }

    get getUseExperimentalMode() {
        return this.useExperimentalMode;
    }

    setExperimentalMode(value) {
        this.useExperimentalMode = value;
        localStorage.setItem('useExperimentalMode', value);
    }

    setUserId(userId) {
        console.log('setUserId ' + userId);
        localStorage.setItem('userId', userId);
        this.userId = userId;
    }

    setIsPortal(isPortal) {
        this.isAuth = true;
        this.isPortal = isPortal;
        localStorage.setItem('isPortal', isPortal);
    }

    setIsAdmin(isAdmin) {
        this.isAuth = true;
        this.isAdmin = isAdmin;
        localStorage.setItem('isAdmin', isAdmin);
    }

    setUserAuth(isDeveloper) {
        this.isAuth = true;
        this.isDeveloper = isDeveloper;
        localStorage.setItem('isDeveloper', isDeveloper);
    }

    setUserNonAuth() {
        this.isAuth = false;
    }

    setUseExtendedPanel(value) {
        this.useExtendedPanel = value;
        localStorage.setItem('useExtendedPanel', value);
    }

    closeLogin() {
        this.isOpen = false;
    }

    openLogin(callback) {
        console.log('openLogin');
        this.isOpen = true;
        this.callback = callback;
    }

    get getCallback() {
        return this.callback;
    }
}

const authStore = new AuthStore();

export default authStore;
export { AuthStore };